import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import Sidebar from "./Sidebar";

const Mypage = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar />
      <Box sx={{ width: "200px", flex: "0 0 200px" }} />
      <Box sx={{ flex: 1, px: 0, minWidth: 0 }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Mypage;
